export function formatText(text: string) {
  if(!text){
    return "";
  }
    return text
      .split("_") // Split the text by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back with spaces
}

export function replaceUnderscoresWithSpace(val: any): any {
  if (typeof val === "string" && val !== "--") {
    if (!val.includes("@") && !val.includes("http") && !val.includes(":\\") && !val.includes("/") && !val.startsWith("#")) {
      return val.replace(/_/g, " ");
    }
  }
  return val;
}

  